<template>
  <div class="pay-succ">
    <iconpark-icon name="circle-success" class="text-[40px]"></iconpark-icon>
    <div class="pay-succ__h1">{{ $t('zhi-fu-cheng-gong') }}</div>
    <div class="pay-succ__h2">{{ title }}</div>
    <div class="pay-succ__h3">{{ desc }}</div>
    <div v-if="showPullNewInfo" class="text-center text-font-70 mt-[15px]">
      <div>
        <div v-if="inviteProps?.award.accept_total_credit_coins">
          {{
            $t(
              'nin-yi-wan-cheng-hao-you-zhu-li-jiang-li-nin-invitepropsawardaccepttotalcreditcoins-yan-bi',
              [inviteProps.award.accept_total_credit_coins]
            )
          }}
        </div>
        <div v-if="inviteProps?.award.invitation_total_credit_coins">
          <span v-if="!inviteProps.award.accept_total_credit_coins">
            {{ $t('nin-yi-wan-cheng-hao-you-zhu-li') }}
          </span>
          {{
            $t(
              'nin-de-hao-you-huo-de-invitepropsawardinvitationtotalcreditcoins-yan-bi',
              [inviteProps.award.invitation_total_credit_coins]
            )
          }}
        </div>
        <div>
          {{ $t('kuai-lai-huo-qu-nin-de') }}
          <a @click="inviteProps?.cb">
            {{ $t('zhuan-shu-yao-qing-lian-jie') }}
          </a>
          ，{{ $t('yao-qing-hao-you-gong-xiang-quan-yi-ba') }}
        </div>
      </div>
    </div>
    <div class="pay-succ__h3">
      <span>{{ seconds }}s 后关闭页面</span>
      <span v-if="tip">，{{ tip }}</span>
    </div>
  </div>
</template>

<script setup lang="ts" name="PaySucc">
import type { Loose } from '~/api/interface'
import { LOCAL_KEY } from '~/constants/config'
import { clearModals } from '~/hooks/useModal/modals/empty'

const { inviteProps } = defineProps<{
  title?: string
  desc?: string
  tip?: string
  inviteProps?: {
    isInviteUser: boolean // 是否是被邀请用户
    award: Loose // 奖励内容
    cb(): void // 点击专属链接的回调
  }
}>()

const route = useRoute()

const payType = computed(() => route.query?.pay_type)

// 显示邀请信息
const showPullNewInfo = computed(
  () =>
    inviteProps?.isInviteUser &&
    (inviteProps?.award.accept_total_credit_coins ||
      inviteProps?.award.invitation_total_credit_coins)
)

const emits = defineEmits(['onSuccess'])

const timer: any = ref()
const seconds = ref(5)
onMounted(() => {
  timer.value = setInterval(() => {
    if (seconds.value <= 0) {
      emits('onSuccess')
      clearInterval(timer.value)
      localSetItem(LOCAL_KEY.UPDATE_USERINFO, Date.now())
      if (payType.value) {
        window.close()
      } else {
        clearModals()
        location.reload()
      }
      return
    }
    seconds.value--
  }, 1000)
})
</script>

<style lang="scss" scoped>
.icon {
  color: var(--success-9);
}
.pay-succ {
  padding: 30px;
  min-height: 290px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  &__h1 {
    margin-top: 12px;
    font-size: 16px;
    font-weight: bold;
  }
  &__h3 {
    font-size: 16px;
    line-height: 24px;
    color: var(--warning-8);
  }
  &__h2 {
    font-size: 40px;
    font-weight: 400;
    color: var(--text-1);
  }
}
</style>
